import { apiClient } from "@/lib/api-client";

export const getAkumulasiIku = async (
  niu: string,
  year: string | number,
  semester: string | number,
  periodeID: string | number,
  month?: string | null,
) => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  const params = new URLSearchParams({
    year: String(year),
    semester: String(semester),
    periodeID: String(periodeID),
  });
  if (month) {
    params.append("month", month);
  }
  const response = await apiClient<any>(
    `${baseUrl}/api/v1/akumulasi/${niu}/remun-iku?${params.toString()}`,
  );

  return response;
};
